<template>
  <div class="home">
    <div class="container">
      <div id="welcome-nav" class="text-center">
        <router-link to="/">About</router-link>
        <span class="welcome-nav-separator">|</span>
        <router-link to="/register">Register</router-link>
        <span class="welcome-nav-separator">|</span>
        <router-link to="/login">Login</router-link>
      </div>
      <div id="welcome-layout-alerts">
        <flash-message></flash-message>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  methods: {}
};
</script>


<style>
#welcome-layout-alerts {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

#welcome-nav {
  padding: 20px;
}

#welcome-nav a {
  padding: 5px;
  color: #666;
}

#welcome-nav a.router-link-exact-active {
  color: #111;
  font-weight: bold;
  /* text-decoration: underline; */
  /* background-color: #111; */
}

.welcome-nav-separator {
  margin-left: 0.5em;
  margin-right: 0.5em;
}


</style>